// custom logic for confirming a delete and handling DELETE methods!
document.addEventListener('click', function (event) {
  const el = event.target.closest('a[data-turbo-method="delete"], a[data-method="delete"]');
  if (!el) {
    // Just confirmation logic for other elements
    const confirmEl = event.target.closest('[data-confirm], [data-turbo-confirm]');
    if (!confirmEl) return;
    
    const message = confirmEl.getAttribute('data-confirm') || confirmEl.getAttribute('data-turbo-confirm');
    if (message && !confirm(message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    return;
  }

  // Handle DELETE link
  event.preventDefault();
  
  const message = el.getAttribute('data-confirm') || el.getAttribute('data-turbo-confirm');
  if (message && !confirm(message)) return;

  // Create a hidden form and submit it
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = el.href;
  form.style.display = 'none';

  const methodInput = document.createElement('input');
  methodInput.type = 'hidden';
  methodInput.name = '_method';
  methodInput.value = 'DELETE';
  form.appendChild(methodInput);

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  if (csrfToken) {
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = 'authenticity_token';
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);
  }

  document.body.appendChild(form);
  form.submit();
});

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (e) => {
    if (e.target.matches('[data-dismiss-button]')) {
      const banner = e.target.closest('[data-dismissible]');
      if (banner) banner.remove();
    }
  });
});
